import s from "./info.module.css";
import Breadcrumbs from "../../assets/Components/breadcrumbs/breadcrumbs";
import React from "react";
import useDocumentTitle from "../../assets/Tools/DocumentTitle/DocumentTitle";


const Security = () => {

    useDocumentTitle('Безопасность');

    return (
        <div className={s.info}>
            <div className={`${s.infoContent} content`}>
                <Breadcrumbs/>
                <div className={s.security}>
                    <h3>Политика безопасности</h3>
                    <p>В интернет-магазине "Статус-Текстиль" делать покупки не только выгодно но и безопасно. Мы
                        стремимся не потерять репутацию порядочного и доброжелательного магазина, поэтому, для Вашего
                        спокойствия и безопасности мы не требуем предоплату, а предоставляем Вам возможность оплачивать
                        покупку при получении. Конечно, этому сопутствуют небольшие дополнительные расходы по тарифам
                        транспортных компаний. Тем не менее, мы уважаем Ваш выбор и учитываем Ваши пожелания.
                    </p>
                    <p>"Статус-Текстиль" открыт к общения, все номера телефонов доступны практически круглосуточно.
                    </p>
                    <p>Вы можете оставить запрос у нас в чате и мы обязательно Вам перезвоним.
                    </p>
                    <p>Вы также можете оставить запросы или задать любые интересующие Вас вопросы, написав нам на
                        электронную почту.
                    </p>
                    <p>Для Вас так же открыты наши <strong>группы и странички в соц.сетях</strong>: вконтакте, фейсбук,
                        инстаграм, твиттер. Ссылки на группы - вверху главной странички нашего сайта.
                    </p>
                </div>
            </div>
        </div>
    )
}

export default Security;